import { tariffBuyCustomFeatures } from 'reactApp/appHelpers/featuresHelpers';
import {
    AI_TARIFF_TOOLBAR_TOOLTIP_BUY_TITLE,
    AI_TARIFF_TOOLBAR_TOOLTIP_CAMPAIGN_IDS,
    AI_TARIFF_TOOLBAR_TOOLTIP_FEATURES_ID,
    AI_TARIFF_TOOLBAR_TOOLTIP_PRODUCT_ID,
} from 'reactApp/appHelpers/featuresHelpers/features/aiTariffToolbarTooltip';
import { openBuyCheckout } from 'reactApp/modules/payment/payment.module';
import { store } from 'reactApp/store';

export const addAITariffToolbarListeners = () => {
    const headline = document.querySelector('#ph-whiteline');
    if (headline) {
        headline.addEventListener('promoBalloonCompleteClick', (evt) => {
            const detail = evt.detail;

            if (detail.project === 'mailspace' && AI_TARIFF_TOOLBAR_TOOLTIP_CAMPAIGN_IDS.includes(String(detail.campaignId))) {
                evt.preventDefault();

                store.dispatch(
                    openBuyCheckout({
                        title: AI_TARIFF_TOOLBAR_TOOLTIP_BUY_TITLE,
                        productId: AI_TARIFF_TOOLBAR_TOOLTIP_PRODUCT_ID,
                        featuresList: tariffBuyCustomFeatures[AI_TARIFF_TOOLBAR_TOOLTIP_FEATURES_ID],
                        paySource: 'ai-tariff-toolbar',
                        hideOtherTariffs: true,
                    })
                );
            }
        });
    }
};
